export const environment = {
    production: false,
    /** Where a promotion from this environment lands. Sandbox is where the client signs off, so promotion goes live. */
    promotionTarget: 'Production',
    tenantClientId: 'Launchcan',
    applicationApi: 'https://pmp-applicationapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    userApi: 'https://pmp-userapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    programmeApi: 'https://pmp-programmeapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    documentApi: 'https://pmp-documentapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    workflowApi: 'https://pmp-workflowapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    formApi: 'https://pmp-formapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1',
    auth0: {
        domain: 'login.sandbox.launchcan.com',
        clientId: '62J2yfKApzPMSP08geLKsUkBW8YndOXd',
        cacheLocation: 'localstorage' as const, // Persist tokens across page refreshes
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: 'https://pmp-logicalapi-sandbox',
            post_sign_up_url: window.location.href,
            custom_claim_prefix: 'pmp-sandbox.eu',
            connection: 'email',
            // Removed 'prompt: login' - it was forcing re-authentication on every page load
        },
    },
    httpInterceptor: {
        allowedList: [
            {
                uri: 'https://pmp-formapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: '/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox' // Optional: if you have an API
                    }
                }
            },
            {
                uri: 'https://pmp-applicationapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: 'https://pmp-applicationapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/v1/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: 'https://pmp-userapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: 'https://pmp-programmeapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: 'https://pmp-documentapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            },
            {
                uri: 'https://pmp-workflowapi-sandbox.icybay-6bfe568c.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-sandbox'
                    }
                }
            }
        ]
    }
}


